module.exports = __webpack_public_path__ + "./docs/img/icon-csharp.a1484010de8176e3a260fbb0c3f250ab.svg";